import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.response.use(function (response) {
  // Do something with response data
  return response;
}, function (error) {
  // Do something with response error
  if (error.response && error.response.status === 403) {
    if (error.response.error) {
      alert(error.error);
    } else {
      alert("Acesso não autorizado!");
    }
  } else if (error.response && error.response.status === 401) {
    localStorage.removeItem("token");
  }
  return Promise.reject(error);
});

export default api;